/* eslint no-shadow: 0 */
import React, { useEffect, useState } from 'react';
import _ from 'underscore';
import { useTranslation } from 'react-i18next';
import AuditHistory from 'components/modules/shipments/AuditHistory';
import DataPoller from 'components/ui/DataPoller';
import CustomerStore from 'stores/CustomerSearchStore';
import CustomerActionCreators from 'actions/CustomersActionCreators';
import AccountContacts from 'components/v2/contacts';
import SessionStore from 'stores/SessionStore';
import RecentActivity from 'components/modules/user/recent-activity';
import CargomaticCard from 'components/v2/card';
import CargomaticModal from 'components/v2/modal';
import ConsigneeForm from './consignee-form';
import ConsigneeProfileCard from './consignee-profile-card';
import ConsigneeAccountCard from './consignee-account-card';
import ConsigneeAddressCard from './consignee-address-card';
import InviteConsigneeModal from './invite-consignee-modal';
import NotificationsManager from '../../notifications/manage-notifications';
const POLLING_FREQ = 10000;
const ConsigneeDetails = ({ consignee, onSaveDetails, onChangePasswordClick, }) => {
    const { t } = useTranslation();
    const [showAccountModal, setShowAccountModal] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [showInviteConsigneeModal, setShowInviteConsigneeModal] = useState(false);
    const [category, setCategory] = useState(null);
    const [audits, setAudits] = useState([]);
    const onAuditChange = () => {
        const custumerAudits = CustomerStore.getCustomerAudits();
        if (!_.isEqual(custumerAudits, audits)) {
            return setAudits(custumerAudits);
        }
    };
    const onSave = (updates) => {
        onSaveDetails(updates);
        setShowAccountModal(false);
    };
    useEffect(() => {
        const isAdminUser = SessionStore.isAdmin();
        setIsAdmin(isAdminUser);
        CustomerStore.addAuditChangeListener(onAuditChange);
    }, []);
    function renderModalComponent() {
        return (React.createElement(ConsigneeForm, { category: category, details: consignee, onSave: (data) => onSave(data) }));
    }
    const getUserAudits = () => {
        CustomerActionCreators.fetchCustomerAudits(consignee === null || consignee === void 0 ? void 0 : consignee._id);
    };
    function openModal(categoryName) {
        setShowAccountModal(true);
        setCategory(categoryName);
    }
    return (React.createElement("div", { className: "mx-auto my-16 max-w-screen-2xl md:my-32 lg:my-16" },
        React.createElement(DataPoller, { action: getUserAudits, frequency: POLLING_FREQ }),
        React.createElement("div", { className: "lg:grid lg:grid-cols-4 lg:gap-6" },
            React.createElement("div", { className: "col-span-1" },
                React.createElement(ConsigneeProfileCard, { consignee: consignee }),
                React.createElement(ConsigneeAccountCard, { consignee: consignee, onEditAccount: () => openModal('account') }),
                React.createElement("div", { className: "mt-6" },
                    React.createElement("button", { className: "w-full button button-hollow-red", onClick: onChangePasswordClick }, t('CHANGE_PASSWORD'))),
                isAdmin && (React.createElement("div", { className: "mt-6" },
                    React.createElement("button", { className: "w-full button button-hollow-green", onClick: () => {
                            setShowInviteConsigneeModal(true);
                        } }, t('INVITE_CONSIGNEE'))))),
            React.createElement("div", { className: "col-span-2" },
                isAdmin && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "mb-6" },
                        React.createElement(RecentActivity, { email: consignee === null || consignee === void 0 ? void 0 : consignee.email })),
                    React.createElement(CargomaticCard, { className: "mb-6", header: () => React.createElement("h3", { className: "my-0" }, t('AUDIT_HISTORY')) },
                        React.createElement(AuditHistory, { audits: audits, paginate: true })))),
                React.createElement(AccountContacts, { contacts: consignee === null || consignee === void 0 ? void 0 : consignee.contacts, userId: consignee === null || consignee === void 0 ? void 0 : consignee._id, className: "mb-6" }),
                React.createElement(NotificationsManager, { userNotificationPreferences: consignee })),
            React.createElement("div", { className: "col-span-1" },
                React.createElement(ConsigneeAddressCard, { consignee: consignee, onEditAccount: () => openModal('address') }))),
        showAccountModal && (React.createElement(CargomaticModal, { show: true, backdrop: "static", onHide: () => setShowAccountModal(false), title: t('ACCOUNT_INFORMATION'), body: renderModalComponent(), footer: null, location: "middle" })),
        showInviteConsigneeModal && (React.createElement(InviteConsigneeModal, { consignee: consignee, onHideModal: () => setShowInviteConsigneeModal(false) }))));
};
export default ConsigneeDetails;
